<template>
  <section class="list-badges">
    <draggable :options="{group:'badge', disabled: isOneOpen}" v-model="list" :move="startMoving">
      <empty class="badge-list-empty" v-if="badges.length === 0" :title="$t('badge.empty.title')" :message="$t('badge.empty.message')"><a @click="toggleCreateBadge(campaign)">{{ $t('badge.actions.create') }}</a></empty>
      <badge v-else v-for="(badge, index) in sorted" :key="badge.id" :badge="badge" :class="classLastChild(index)"></badge>
    </draggable>
    <create-badge v-if="modal.createBadge" :idCampaign="campaign.id" @close="closeCreateBadge"></create-badge>
  </section>
</template>

<script>
import Badge from './Badge.vue'
import CreateBadge from './../badges/FormBadge.vue'
import draggable from 'vuedraggable'
import { mapActions, mapGetters } from 'vuex'
import Empty from '@/components/box-entity-empty.vue'

export default {
  components: { Badge, CreateBadge, draggable, Empty },
  props: ['badges', 'campaign'],
  data () {
    return {
      modal: {
        createBadge: false
      }
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('badges', {
      getById: 'getById',
      badgeMoving: 'badgeMoving'
    }),
    ...mapGetters('modals', ['isOneOpen']),
    sorted: function () {
      return this.badges.slice().sort(function (a, b) {
        return a.order - b.order
      })
    },

    list: {
      get () {
        return this.badges
      },
      set (badges) {
        let moving = this._.cloneDeep(this.badgeMoving, false)
        let order = 1
        badges.forEach((badge) => {
          if (moving.id === badge.id) {
            let bdg = {
              id: badge.id,
              order: order,
              category: {id: this.campaign.id},
              parent: {}
            }
            this.moveBadge({badge: bdg})
          }
          order++
        })
      }
    }
  },
  methods: {
    ...mapActions('badges', ['startMove', 'moveBadge']),

    toggleCreateBadge (campaign, index) {
      this.modal.createBadge = !this.modal.createBadge
    },
    closeCreateBadge (campaign, index) {
      this.modal.createBadge = false
    },
    startMoving (evt) {
      let badge = this.getById(evt.draggedContext.element.id)
      this.startMove(badge)
    },
    classLastChild (index) {
      if (this.sorted.length === (index + 1)) {
        return 'last-child'
      }
      return null
    }
  }
}
</script>

<style lang="scss">
/* base */
.company {
  z-index: 1;
}

/* moving */
.company-move {
  transition: all 600ms ease-in-out 50ms;
}

/* appearing */
.company-enter-active {
    transform: scale(1);
    transition: all 400ms ease-out;
}

/* disappearing */
.company-leave-active {
    transition: all 400ms ease-in;
    transform: scale(0);
    max-height: 0;
}

/* appear at / disappear to */
.company-enter {
    transform: scale(0);
    opacity: 0;
}

.list-badges {
  margin-top:12px;
  border-top:1px solid #eaefea;
  border-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/badges/BadgeList.vue